import {LOCATION_TYPES} from '@/globals';
import {DocumentationModel} from '../documentation/documentation.model';
import {CoresGroup} from './cores-group.model';
import {DistributionPanelModel} from './distrubution-panel.model';
import {EquipmentCapModel} from './equipment-cap.model';
import {EquipmentConnectorPinModel} from './equipment-connector-pin.model';
import {EquipmentDetailModel} from './equipment-detail.model';
import {EquipmentPinModel} from './equipment-pin.model';
import {JunctionBoxDetailModel} from './junction-box-detail.model';
import {LocationConnectionModel} from './location-connection.model';
import {LocationDetailModel} from './location-detail.model';
import {SwitchBoardModel} from './switch-boards.model';
import {TerminalBlockModel} from './terminal-block.model';
import {WiringCableModel} from './wiring-cables.model';

export class LocationModel {
    id?: string | null = null;
    title: string | null = null;
    sequence?: number;
    type?: LOCATION_TYPES | null = null;
    created?: Date;
    updated?: Date;
    siteId?: string | null = null;
    locations?: Location[] = [];

    locationId?: string | null = null;

    equipmentDetail?: EquipmentDetailModel | null = null;
    junctionBoxDetail?: JunctionBoxDetailModel | null = null;
    distributionPanel?: DistributionPanelModel | null = null;
    locationDetail?: LocationDetailModel | null = null;
    documentations?: Array<DocumentationModel> | null = null;
    switchBoards?: Array<SwitchBoardModel> | [] = [];
    wiringCables?: WiringCableModel[] = [];
    coresGroups?: CoresGroup[] = [];

    equipmentPins?: Array<EquipmentPinModel> | null = undefined;
    equipmentCaps?: Array<EquipmentCapModel> | null = undefined;
    equipmentConnectorPins?: Array<EquipmentConnectorPinModel> | null = undefined;

    fromLocationConnections?: Array<LocationConnectionModel> | null = undefined;
    toLocationConnections?: Array<LocationConnectionModel> | null = undefined;

    parentLocation?: LocationModel | null = null;

    terminalBlock?: TerminalBlockModel | null = null;

    parentId?: string | null = null;

    [key: string]: any;

    constructor(data?: Partial<LocationModel>) {
        Object.assign(this, data);
        if (!data?.equipmentDetail) {
            this.equipmentDetail = new EquipmentDetailModel();
        } else {
            if (typeof data.equipmentDetail.ipy === 'string') {
                data.equipmentDetail.ipy = [data.equipmentDetail.ipy];
            }
            this.equipmentDetail = new EquipmentDetailModel(data?.equipmentDetail);
        }
        if (!data?.distributionPanel) {
            this.distributionPanel = new DistributionPanelModel();
        } else {
            this.distributionPanel = new DistributionPanelModel(data?.distributionPanel);
        }
        if (!data?.junctionBoxDetail) {
            this.junctionBoxDetail = new JunctionBoxDetailModel();
        } else {
            this.junctionBoxDetail = new JunctionBoxDetailModel(data?.junctionBoxDetail);
        }
        // if (!data?.switchBoards) {
        //     this.switchBoards = new SwitchBoardModel();
        // } else {
        //     this.distributionPanel = new SwitchBoardModel(data?.switchBoards);
        // }
        if (!data?.locationDetail) {
            this.locationDetail = new LocationDetailModel();
        } else {
            this.locationDetail = new LocationDetailModel(data.locationDetail);
        }
    }
}
